import { useQueryClient } from 'react-query'
import { useSetRecoilState } from 'recoil'
import toast from 'react-hot-toast'
import { useChangeState, useGetStageRecords } from '../../api/stage'
import {
  modalContentState,
  modalOpenState,
  notesPanelOpenState,
} from '../../atoms/layout'
import { StageState, TRANSLATE } from '../../types/stage-state'
import AcceptModal from '../common/AcceptModal'
import PanelContainer from '../common/PanelContainer'
import Button from '@mui/material/Button'
import { Chip, Stack, Typography } from '@mui/material'

interface Props {
  className?: string
  stageId: string
}

export default function RecordsPanel({ stageId, className }: Props) {
  const setModalOpen = useSetRecoilState(modalOpenState)
  const setModalContent = useSetRecoilState(modalContentState)
  const { data: records } = useGetStageRecords(stageId)
  const changeState = useChangeState(stageId)
  const queryClient = useQueryClient()

  const isAccepted = records?.slice(-1)?.[0]?.state === StageState.ACCEPTED

  function submitStage() {
    setModalContent(
      <AcceptModal
        title={isAccepted ? 'برگشت دادن' : 'ثبت مرحله'}
        question={`آیا از ${isAccepted ? 'برگشت دادن' : 'ثبت'} مرحله اطمینان دارید؟`}
        onConfirm={async () => {
          await changeState.mutateAsync(isAccepted ? 1 : 0)
          queryClient.invalidateQueries()
          toast.success('تغییر وضعیت مرحله انجام شد.')
        }}
      />
    )
    setModalOpen(true)
  }

  return (
    <PanelContainer
      heightState={notesPanelOpenState}
      resizeButton
      title="اطلاعات کلی"
      id="records-panel"
    >
      {records?.length !== 0 && (
        <Button
          id="change-stage-status"
          variant="contained"
          fullWidth
          color={isAccepted ? 'error' : 'primary'}
          onClick={submitStage}
        >
          {isAccepted ? 'برگشت دادن' : 'ثبت مرحله'}
        </Button>
      )}
      {records?.length === 0 && (
        <Typography fontSize="small" textAlign="center" color="text.secondary">
          این مرحله هنوز فعال نشده.
        </Typography>
      )}
      <Stack sx={{ flexGrow: 1, mt: 2 }} gap={1} id="stage-history">
        {records
          ?.slice()
          .reverse()
          ?.map((record) => (
            <div className="flex flex-row justify-between text-zinc-600" key={record.id}>
              <Chip label={TRANSLATE[record.state]} />
              <div className="text-zinc-500">
                {new Date(record.createdAt).toLocaleString('fa-IR', {
                  dateStyle: 'medium',
                  timeStyle: 'short',
                })}
              </div>
            </div>
          ))}
      </Stack>
    </PanelContainer>
  )
}
